import clsx from "clsx"
import * as React from "react"
import Richtext from "../../atoms/RichText"

interface Props {
  content: any
  classes?: string
  applyDefaultStyle?: boolean
}

/**
 * Paragraph Component
 * @param content (optional) - Text of the paragraph.
 * @param classes (optional) - Tailwindcss classes to customize it.
 */
const Paragraph = ({ content, classes = "", applyDefaultStyle = true }: Props) => {
  return (
    <>
      {!content?.nodeType && (
        <p
          data-testid="paragraph"
          className={clsx(applyDefaultStyle && "text-container text-md", classes)}
          dangerouslySetInnerHTML={{ __html: content }}
        ></p>
      )}
      {content?.nodeType && <Richtext content={content} classes={classes} />}
    </>
  )
}

export default Paragraph
